import { useGetVideoCredits } from '@vimeo/gctl-api/hooks/useVideoCredits';
import { getAvatarImages } from '@vimeo/user-card';
import { useViewer } from '@vimeo/viewer';

import { useSelectedId } from './use-selected-id';

export function useVideoCredits() {
  const viewer = useViewer();
  const { selectedId } = useSelectedId();

  const { data: creditsData } = useGetVideoCredits(
    () => {
      if (!viewer || !selectedId) return null;

      return {
        where: { videoId: Number(selectedId) },
        select: ['name', 'role', 'uri', 'user.pictures', 'user.link'],
        query: {
          page: 1,
          perPage: 10,
        },
      };
    },
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    },
  );

  const credits = creditsData?.data.map((credit) => {
    const [avaSrc, avaSrcSet] = getAvatarImages(credit?.user?.pictures?.sizes);
    return {
      name: credit.name,
      avaSrc,
      avaSrcSet,
      role: credit.role,
      uri: credit.uri,
      userLink: credit.user?.link ?? '',
    };
  });

  return credits;
}
